import { render } from "./FinanceDashboard.vue?vue&type=template&id=0f985680&scoped=true&ts=true"
import script from "./FinanceDashboard.vue?vue&type=script&lang=ts"
export * from "./FinanceDashboard.vue?vue&type=script&lang=ts"

import "./FinanceDashboard.vue?vue&type=style&index=0&id=0f985680&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f985680"]])

export default __exports__